import React from 'react';
import { PropTypes } from 'prop-types';
import { withStyles } from '@material-ui/styles';
import errorImage from '../../../assets/images/errorImage.png';
import MessagesContext from '../../../contexts/messagesContext';
import SubmitButton from '../Buttons/SubmitButton';
import { withRouter } from 'react-router-dom';

const styles = {
    container: {
        marginTop: '15px'
    },
    imageWrapper: {
        width: '250px',
        height: '250px',
        '& img': {
            width: '100%',
            height: '100%'
        }
    },
    messageWrapper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        '& > span': {
            marginTop: '15px'
        }
    },
    buttonWrapper: {
        marginTop: '24px',
        width: '135px'
    },
    '@global': {
        iframe: {
            // display: process.env.NODE_ENV === 'production' && 'none'
            display: 'none'
        }
    }
};

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { errorMessage: null, hasError: false };
    }
    static propTypes = {
        children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
            .isRequired,
        classes: PropTypes.object,
        history: PropTypes.object
    };

    componentDidCatch(error) {
        this.setState({
            errorMessage: error.message,
            hasError: true
        });
    }
    handleBack = () => {
        this.props.history.goBack();
    };

    render() {
        const { classes } = this.props;
        if (this.state.hasError) {
            return (
                <div className={classes.container}>
                    <div className={classes.messageWrapper}>
                        <div className={classes.imageWrapper}>
                            <img src={errorImage} alt="errorImage" />
                        </div>
                        <MessagesContext.Consumer>
                            {({ messages }) => (
                                <>
                                    <h2>{messages.errorOccurred}!</h2>
                                    <div dir="ltr">
                                        <b>error message:</b> {this.state.errorMessage}
                                    </div>
                                    <div className={classes.buttonWrapper}>
                                        <SubmitButton
                                            fullWith
                                            mr={'0'}
                                            isButton
                                            handleClick={this.handleBack}
                                            submitText={messages.back}
                                        />
                                    </div>
                                </>
                            )}
                        </MessagesContext.Consumer>
                    </div>
                </div>
            );
        }
        return this.props.children;
    }
}
export default withRouter(withStyles(styles)(ErrorBoundary));
